import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  organizationsAll: [],
  totalOrganizations: null,
  organizations: [],
  organization: {},
  organizationBossList: [],
}

export const mutations = {
  SET_ORGANIZATIONS_ALL(state, organizations) {
    state.organizationsAll = organizations
  },
  SET_TOTAL_ORGANIZATIONS(state, totalOrganizations) {
    state.totalOrganizations = totalOrganizations
  },
  SET_ORGANIZATIONS(state, organizations) {
    state.organizations = organizations
  },
  SET_ORGANIZATION(state, organization) {
    state.organization = organization
  },
  ADD_ORGANIZATION(state, organization) {
    state.organizations.push(organization)
  },
  EDIT_ORGANIZATION(state, organization) {
    const index = state.organizations.findIndex(
      (el) => el.organization_uuid === organization.organization_uuid
    )
    if (index !== -1) {
      state.organizations.splice(index, 1, organization)
    }
  },
  DELETE_ORGANIZATION(state, uuid) {
    const index = state.organizations.findIndex(
      (el) => el.organization_uuid === uuid
    )
    if (index !== -1) state.organizations.splice(index, 1)
  },
  ADD_ORGANIZATION_BOSS(state, organizationBoss) {
    const index = state.organizationBossList.findIndex(
      (el) => el.employee_id === organizationBoss.employee_id
    )
    if (index === -1) state.organizationBossList.push(organizationBoss)
  },
  DELETE_ORGANIZATION_BOSS(state, id) {
    const index = state.organizationBossList.findIndex(
      (el) => el.employee_id === id
    )
    if (index !== -1) state.organizationBossList.splice(index, 1)
  },
  SET_ORGANIZATION_BOSS(state) {
    state.organizationBossList = []
  },
}

export const actions = {
  fetchOrganizationsAuthorized({ commit }, payload) {
    return ApiService.fetchOrganizationsAuthorized(payload)
      .then((res) => {
        const { data: organizations, total: totalOrganizations } = res.data
        commit('SET_ORGANIZATIONS', organizations)
        commit('SET_TOTAL_ORGANIZATIONS', totalOrganizations)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchOrganizationsAuthorizedTree(_, payload) {
    return ApiService.fetchOrganizationsAuthorizedTree(payload)
      .then((res) => {
        const organizations = res.data
        return organizations
      })
      .catch((error) => {
        throw error
      })
  },
  fetchOrganizationsAll({ commit }, payload) {
    return ApiService.fetchOrganizations(payload)
      .then((res) => {
        const organizations = res.data.data
        commit('SET_ORGANIZATIONS_ALL', organizations)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchOrganizationsFilter(_, payload) {
    return ApiService.fetchOrganizations(payload)
      .then((res) => {
        return { total: res.data.total, organizations: res.data.data }
      })
      .catch((error) => {
        throw error
      })
  },
  fetchOrganizations({ commit }, payload) {
    return ApiService.fetchOrganizations(payload)
      .then((res) => {
        const organizations = res.data.data.map((organization) => {
          if (organization.root_organization === null) {
            return {
              ...organization,
              root_organization: { organization_uuid: null },
            }
          }
          return organization
        })
        commit('SET_ORGANIZATIONS', organizations)
        commit('SET_TOTAL_ORGANIZATIONS', res.data.total)
      })
      .catch((error) => {
        throw error
      })
  },
  fetchOrganization({ commit }, payload) {
    return ApiService.fetchOrganization(payload)
      .then((res) => {
        const organization = res.data
        commit('SET_ORGANIZATION', organization)
        return organization
      })
      .catch((error) => {
        throw error
      })
  },
  addOrganization({ commit }, payload) {
    return ApiService.addOrganization(payload)
      .then((res) => {
        const organization = res.data
        commit('ADD_ORGANIZATION', organization)
        return organization
      })
      .catch((error) => {
        throw error
      })
  },
  editOrganization({ commit }, payload) {
    return ApiService.editOrganization(payload)
      .then((res) => {
        const organization = res.data
        commit('EDIT_ORGANIZATION', organization)
        commit('SET_ORGANIZATION', organization)
      })
      .catch((error) => {
        throw error
      })
  },
  deleteOrganization({ commit }, payload) {
    return ApiService.deleteOrganization(payload)
      .then(() => {
        commit('DELETE_ORGANIZATION', payload.organization_uuid)
      })
      .catch((error) => {
        throw error
      })
  },
  editOrganizationBoss(_, payload) {
    return ApiService.editOrganizationBoss(payload)
      .then(() => {})
      .catch((error) => {
        throw error
      })
  },
  fetchOrganizationBoss(_, payload) {
    return ApiService.fetchOrganizationBoss(payload)
      .then((res) => {
        const organizationBoss = res.data.data
        return organizationBoss
      })
      .catch((error) => {
        throw error
      })
  },
  deleteOrganizationBoss(_, payload) {
    return ApiService.deleteOrganizationBoss(payload)
      .then(() => {})
      .catch((error) => {
        throw error
      })
  },
}

export const getters = {
  getOrganizationById: (state) => (id) => {
    return state.organizations.find((el) => el.organization_id === id)
  },
}
